module.exports = __webpack_public_path__ + "img/5277f9d.jpg";